<template>
  <v-container fluid>
    <v-progress-linear v-if="loader" indeterminate color="primary"/>
    <v-snackbar v-model="copySuccess" top color="deep-purple" elevation="24">You just copied!</v-snackbar>
    <v-snackbar v-model="copyError" top color="deep-purple" elevation="24">Failed to copy texts!</v-snackbar>
    <v-row v-if="!loader">
      <v-col cols="12" md="6">
        <v-card elevation="0">
          <v-btn :to="{name: 'dashboard'}" text rounded>
            <v-icon>fa-angle-left</v-icon>
            <v-card-title class="text-uppercase">{{ content.status }}</v-card-title>
          </v-btn>
          <v-card-text>
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-title>Global Order ID <span class="text-primary pointer" v-clipboard:copy="content.contractor_order_id" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ content.contractor_order_id }} <v-icon color="primary" small>fa-copy</v-icon></span></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-title>Agent order ID <span class="text-primary pointer" v-clipboard:copy="content.agent_order_id" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ content.agent_order_id }} <v-icon color="primary" small>fa-copy</v-icon></span></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <ul class="d-flex mt-5 list-unstyled" v-if="content.order_type">
              <li>{{ content.order_type }}</li>
            </ul>
            <v-row class="mb-5">
              <v-col>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>Scheduled (agent) <br><p class="mt-2 mb-0"><b>{{ content.created_at }}</b></p></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>Class <br><p class="mt-2 mb-0"><b class="text-capitalize">{{ content.class }}</b></p></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <v-row class="mb-2">
              <v-col>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>Price raw <br><p class="mt-2 mb-0"><b>{{ content.details && content.details.price_raw ? content.details.price_raw : '-' }}</b></p></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <v-row class="mb-2">
              <v-col>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>Price details <br> <json-view v-if="content.details && content.details.price_details" :data="content.details && content.details.price_details" /> <p v-else class="mt-2 mb-0"><b>-</b></p>  </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <v-divider/>
            <v-timeline dense>
              <v-timeline-item small>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong>{{ content.created_at }}</strong>
                  </v-col>
                  <v-col>
                    <strong>Booked by</strong>
                    <div class="text-caption">{{ content.user ? content.user.phone : '' }}</div>
                    <v-divider class="mt-3"/>
                  </v-col>
                </v-row>
                <v-row class="pt-1">
                  <v-col cols="3"/>
                  <v-col>
                    <strong>Driver confirmed</strong>
                    <div class="text-caption">{{ content.driver ? content.driver.name : '---' }} {{ content.vehicle ? content.vehicle.model : '---' }} {{ content.vehicle ? content.vehicle.plates : '---' }}</div>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
            <v-divider/>
            <v-timeline dense v-if="content.address_point_a && content.address_point_b">
              <v-timeline-item small>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="text-h4">1</strong>
                    <strong class="d-block">{{ content.ended_at }}</strong>
                  </v-col>
                  <v-col>
                    <strong>{{ content.address_point_a }}</strong>
                    <div class="text-caption">{{ content.driver ? content.driver.name : '---' }} {{ content.vehicle ? content.vehicle.model : '---' }} {{ content.vehicle ? content.vehicle.plates : '---' }}</div>
                    <v-divider class="mt-3"/>
                  </v-col>
                </v-row>
              </v-timeline-item>
              <v-timeline-item small>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="text-h4">2</strong>
                  </v-col>
                  <v-col>
                    <strong>{{ content.address_point_b }}</strong>
                    <div class="text-caption">{{ content.driver ? content.driver.name : '---' }} {{ content.vehicle ? content.vehicle.model : '---' }} {{ content.vehicle ? content.vehicle.plates : '---' }} | {{ content.travel_time ? `${content.travel_time} (min)` : '' }} {{ content.distance ? `${content.distance} km` : ''}}</div>
                    <v-divider class="mt-3"/>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
            <v-timeline dense else>
              <template v-for="(item, index) in content.route">
                <v-timeline-item small v-if="item.fullname && index === 0" :key="index">
                  <v-row class="pt-1">
                    <v-col cols="3">
                      <strong class="text-h4">1</strong>
                    </v-col>
                    <v-col>
                      <strong>{{ item.fullname }}</strong>
                      <div class="text-caption">{{ content.driver ? content.driver.name : '---' }} {{ content.vehicle ? content.vehicle.model : '---' }} {{ content.vehicle ? content.vehicle.plates : '---' }}</div>
                      <v-divider class="mt-3"/>
                    </v-col>
                  </v-row>
                </v-timeline-item>
                <v-timeline-item small v-if="item.fullname && index === Object.keys(content.route).length - 1" :key="index">
                  <v-row class="pt-1">
                    <v-col cols="3">
                      <strong class="text-h4">2</strong>
                      <strong class="d-block">{{ content.ended_at }}</strong>
                    </v-col>
                    <v-col>
                      <strong>{{ item.fullname }}</strong>
                      <div class="text-caption">{{ content.driver ? content.driver.name : '---' }} {{ content.vehicle ? content.vehicle.model : '---' }} {{ content.vehicle ? content.vehicle.plates : '---' }}</div>
                      <v-divider class="mt-3"/>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </template>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <div v-if="content.address_point_a && content.address_point_b" id="map"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '@/axios'
import { loadYmap } from 'vue-yandex-maps'
import { JSONView } from 'vue-json-component'

export default {
  name: 'Trip',
  components: { 'json-view': JSONView },
  data () {
    return {
      loader: true,
      tripId: null,
      copySuccess: false,
      copyError: false,
      yandexSettings: {
        apiKey: '8f6eda58-9a6c-48c2-a995-5d44057c265f',
        lang: 'ru_RU',
        coordorder: 'latlong',
        enterprise: false,
        version: '2.1'
      },
      content: {
        id: '',
        agent_order_id: '',
        agent_id: '',
        agent_name: '',
        contractor_order_id: '',
        address_point_a: '',
        address_point_b: '',
        user: {},
        vehicle: {},
        driver: {},
        comment: '',
        created_at: '',
        ended_at: '',
        order_type: '',
        distance: '',
        travel_time: '',
        status: '',
        class: '',
        special_tariff: ''
      }
    }
  },
  methods: {
    async fetchData (tripId) {
      axios.post(`orders/${tripId}`).then(response => {
        this.content = response.data.data
        this.loader = false
      })
    },
    onCopy: function () {
      this.copySuccess = true
      this.copyError = false
    },
    onError: function () {
      this.copySuccess = false
      this.copyError = true
    }
  },
  async mounted () {
    await this.fetchData(this.$route.params.id)
  },
  async updated () {
    const addressPointA = this.content.address_point_a
    const addressPointB = this.content.address_point_b
    await loadYmap(this.yandexSettings)
    // eslint-disable-next-line no-undef
    ymaps.ready(function () {
      // eslint-disable-next-line no-undef
      const myMap = new ymaps.Map('map', {
        center: [55.75, 37.65],
        zoom: 7
      })
      // eslint-disable-next-line no-undef
      ymaps.route([
        addressPointA,
        addressPointB
      ], { mapStateAutoApply: true }).then(function (route) {
        myMap.geoObjects.add(route)
        const points = route.getWayPoints()
        const lastPoint = points.getLength() - 1
        points.options.set('preset', 'islands#redStretchyIcon')
        points.get(0).properties.set('iconContent', 'Точка отправления')
        points.get(lastPoint).properties.set('iconContent', 'Точка прибытия')
      })
    })
  }
}
</script>

<style scoped lang="scss">
#map {
  min-height: 350px;
  min-width: 250px;
  height: 100%;
  width: 100%;
  background: #eee;
}

.list-unstyled {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>
